import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/caso1.png";
import Imagen2 from "../../../images/modulo12/caso2.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad4.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[4];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[5].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[5].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[3].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[3].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-8 col-12">
          <ul className="mb-5">
            <li>A veces una misma palabra tiene distintos significados.</li>
            <li>
              Observa las imágenes y lee las frases. ¿Crees que la palabra
              “necesidad” se refiere a lo mismo en los dos casos?
            </li>
          </ul>
        </div>
        <div className="col-lg-10 col-12">
          <h3>Caso 1</h3>
          <img src={Imagen1} alt="Peruanos" className="img-fluid" />
        </div>
        <div className="col-lg-10 col-12 mt-4">
          <h3>Caso 2</h3>
          <img src={Imagen2} alt="Peruanos" className="img-fluid" />
        </div>
        <div className="col-lg-10 col-12 pt-4">
          <p>
            ¿En cuál de los dos casos se trata de una necesidad importante para
            sobrevivir?
          </p>
          <textarea className="form-control mb-3" rows={3} />
          <p>
            ¿En cuál de los dos casos se trata de una necesidad importante para
            convivir?
          </p>
          <textarea className="form-control mb-3" rows={3} />
          <p>
            ¿Crees que los dos tipos de necesidades son igual de importantes?
          </p>
          <textarea className="form-control mb-3" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique a niños y niñas que hay términos polisémicos, es decir,
            palabras que pueden tener distintos significados. Cuando ello
            ocurre, el contexto en que se usa la palabra determinará el
            significado. Antes de trabajar la actividad, brinde algunos
            ejemplos:
            <ul>
              <li>
                <i>
                  “Por ejemplo, la palabra “cola” puede significar la extremidad
                  posterior de los animales, pero también puede significar
                  pegamento o hilera de personas que esperan su turno. El
                  significado que usaremos dependerá de la oración en que se use
                  la palabra. Por ejemplo: «Usé la cola para pegar las patas al
                  tablero de la mesa». En este caso, el contexto de la oración
                  nos indica que el significado de “cola” es pegamento.”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora pida a niños y niñas que observen las imágenes y lean los
            globos en silencio. Pida que describan las imágenes. Por ejemplo:
            <ul>
              <li>
                {" "}
                <i>
                  “En el Caso 1 hay una mamá con su bebito. El doctor le está
                  dando algunas recomendaciones para su alimentación”; “En el
                  Caso 2 hay una profesora que está haciendo una pregunta. Los
                  estudiantes quieren participar y la profesora les pide que lo
                  hagan ordenadamente”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lean las indicaciones de la actividad: A veces una misma palabra
            tiene distintos significados. Observa las imágenes y lee las frases.
            ¿Crees que la palabra “necesidad” se refiere a lo mismo en los dos
            casos? Déles un tiempo para que respondan las preguntas abajo
            planteadas y comente sus respuestas. Por ejemplo:
            <ul>
              <li>
                <i>
                  ¿En cuál de los dos casos se trata de una necesidad importante
                  para sobrevivir? “Se refieren al Caso 1: una buena
                  alimentación es imprescindible para el crecimiento del bebé”.
                </i>
              </li>
              <li>
                {" "}
                <i>
                  ¿En cuál de los dos casos se trata de una necesidad importante
                  para convivir? “En el Caso 2: respetar los turnos para dar
                  nuestra opinión y escuchar las opiniones de nuestros
                  compañeros resulta fundamental para la convivencia”.
                </i>
              </li>{" "}
              <li>
                <i>
                  ¿Crees que los dos tipos de necesidades son igual de
                  importantes? “Debe quedar claro que hay ciertas necesidades
                  fundamentales, que deben ser cubiertas porque son importantes
                  para la supervivencia de las personas”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
